import ubereats from '../assets/pictures/uber.png';
import justeat from '../assets/pictures/justeat.webp';
import deliveroo from '../assets/pictures/delivero.png';
import app from '../assets/pictures/app.svg';
import qrcode from '../assets/pictures/qr-code.svg';
import borne from '../assets/pictures/borne-.svg';

// order status
export const ORDER_PHASE_CONTACTING = 'contacting';
export const ORDER_PHASE_PREPARING = 'preparing';
export const ORDER_PHASE_DELIVERING = 'delivering';
export const ORDER_PHASE_TAKEAWAY = 'takeaway';
export const ORDER_PHASE_WAITER = 'waiter';
export const ORDER_COMPLETED = 'completed';
export const ORDER_SUCCESS = 'success';
export const ORDER_CANCEL = 'cancel';
export const ORDER_REFUND = 'refund';

// order status label
export const ORDER_PHASE_CONTACTING_LABEL = 'En attente';
export const ORDER_PHASE_PREPARING_LABEL = 'En préparation';
export const ORDER_PHASE_DELIVERING_LABEL = 'En livraison';
export const ORDER_PHASE_LOOKING_FOR_DRIVER_LABEL = 'En recherche de livreurs';
export const ORDER_PHASE_TAKEAWAY_LABEL = 'Prête à être emportée';
export const ORDER_PHASE_READY_LABEL = 'Prête';
export const ORDER_PHASE_WAITER_LABEL = 'En attente du serveur';
export const ORDER_CANCELED_LABEL = 'Annulée';
export const ORDER_COMPLETED_LABEL = 'Terminée';
export const ORDER_MISSED_LABEL = 'Manquée';
export const ORDER_REFUND_LABEL = 'Remboursée';
export const ORDER_SHOP_CANCELED_LABEL = 'Refusée';
export const ORDER_PENDING_LABEL = 'En cours';
export const ORDER_PAST = 'ORDER_PAST';
export const ORDER_CANCELED = 'ORDER_CANCELED';

// Order type
export const ORDER_TYPE_DELIVERY = 'delivery';
export const ORDER_TYPE_COLLECT = 'click_and_collect';
export const ORDER_TYPE_SEAT = 'click_and_seat';

// ORDER
export const ORDER_IN_PROGRESS = 'En cours';
export const ORDER_HISTORY = 'Historique';
export const ORDER_FUTURE = 'Dès demain';
// Order canal
export const ORDER_WEBAPP = 'WEBAPP';
export const ORDER_MOBILEAPP = 'MOBILEAPP';
export const ORDER_QRCODE = 'QRCODE';
export const ORDER_DELIVEROO = 'deliveroo';
export const ORDER_JUSTEAT = 'justeat';
export const ORDER_UBEREATS = 'ubereats';
export const ORDER_TERMINAL = 'TERMIAL';

// Canal LOGO
export const TECHS_LOGO = {
  terminal: borne,
  qrcode,
  webapp: app,
  mobileapp: app,
  deliveroo,
  '': app,
  justeat,
  ubereats
};

// Driver
export const DRIVERS_RAYON = 6; // km
export const DRIVER_ONLINE = 'online';

// cancellation
export const CANCEL_CLIENT_UNAVAILABLE = 'client_unavailable';
export const SHOP_CANCEL_AND_REFUND = 'shop_cancel_and_refund';
export const SHOP_CANCEL_PHASE_CONTACTING = 'shop_cancel_phase_contacting';
export const CUSTOMER_CANCEL_PHASE_CONTACTING = 'customer_cancel_phase_contacting';
export const DRIVER_CANCEL_REASSIGNMENT = 'driver_reassignment';

// paymentTypes
export const STRIPE = 'stripe';
export const CB = 'cb';
export const ESPECE = 'cash';
export const TICKET_RESTO = 'ticket_resto';
export const COUTNER = 'counter';

// shop type
export const INDEPENDANT = 'independant';
export const CHAIN = 'chain';
export const FRANCHISE = 'franchise';

// order time
export const ORDER_PHASE_CONTACTING_TIME = 5;
export const ORDER_PHASE_PREPARING_TIME = 15;
export const ORDER_PHASE_DELIVERING_TIME = 15;
// order time
export const UBER = 'UBER';
export const STUART = 'STUART';
export const FLEET = 'FLEET';

export const MODIFY_ORDER_TYPE_PROMOTION = {
  REFUND: 'RF',
  CLICK_AND_COLLECT: 'CNC'
}
export const PICKUP_STATUS = [
  'Actuellement en recherche d’un livreur',
  'Le livreur est en route vers votre restaurant',
  'Le livreur va arriver dans un instant',
  'Le livreur est en route vers votre client'
]
export const PICKUP_STATUS_KEY = {
  ORDER_NOT_CURRENTLY_SUPPORTED: 0,
  DRIVER_ON_THE_WAY_TO_RESTAURANT: 1,
  DRIVER_NEAR_TO_RESTAURANT: 2,
  DRIVER_ON_THE_WAY_TO_CUSTOMER: 3
}
export const ORDER_FLOW_TYPE = {
  CLASSIC: 'classic',
  REVERSE: 'reverse'
}
export const EXTERNAL_DELIVERY_PROVIDERS = ['stuart', 'deliveroo', 'uberDirect']